module.exports = __webpack_public_path__ + "img/VinoTintoJuanGilPlata.9c232e5d.jpg";